import { dummyBannerList } from "@/utils/home-util";

/** 冷蔵庫情報の詳細 */
export interface RootState {
  version: string;
}

//
// API関連
//

// エコナビ情報取得APIのレスポンス
export interface FridgeDetailsEconaviInfoListItemTime {
  date_time: string;          // 時刻 (時刻型) 30分単位の時刻 hh:MM:ss
  operation_status: string;   // エコナビLED状態 エコナビON: ON、エコナビOFF: OFF、欠測の場合: Lack
}
export interface FridgeDetailsEconaviInfoListItem {
  date: string;                   // 日付 (日付型) yyyy-mm-dd
  operating_rate: string;         // エコナビ運転率 0~100 (％)
  econavi_list_time: Array<FridgeDetailsEconaviInfoListItemTime>;	
}
export interface FridgeDetailsEconaviInfoListReasonItem {
  reason_time: string;        // エコナビ解除の時刻（時刻型）
  reason_contents: number;    // エコナビ解除理由の内容 1~9 (取得内容をそのまま返却)
}
export interface FridgeDetailsEconaviInfoDaily {
  econavi_list: Array<FridgeDetailsEconaviInfoListItem>;
  econavi_reason_list: Array<FridgeDetailsEconaviInfoListReasonItem>;
}
export class FridgeDetailsEconaviInfo {
  daily: FridgeDetailsEconaviInfoDaily;

  constructor() {
    this.daily = { econavi_list: [], econavi_reason_list: [] };
  }
}

// ドア開閉情報取得APIのレスポンス
export interface FridgeDetailsDoorOpenInfoDailyItemTime {
  date_time: string;    // 時刻 (時刻型) 1時間単位の時刻(0:00～23:00)
  open_count: number;   // ドア開閉回数
  open_alert: boolean;  // ドア開閉警告有無  true: ドア開閉警告有り false: ドア開閉警告無し		
}
export interface FridgeDetailsDoorOpenInfoDailyItem {
  date: string;         // 日付 (日付型)
  door_open_list_time: Array<FridgeDetailsDoorOpenInfoDailyItemTime>;  // 1時間毎のドア開閉情報リスト
}
export interface FridgeDetailsDoorOpenInfoDaily {
  door_open_list: Array<FridgeDetailsDoorOpenInfoDailyItem>;
}
export interface FridgeDetailsDoorOpenInfoWeeklyItem {
  date: string;           // 日付 (日付型)		
  open_count: number;     // ドア開閉回数		
  open_alert: boolean;    // ドア開閉警告有無 true:ドア開閉警告有り、false:ドア開閉警告無し"		
}
export interface FridgeDetailsDoorOpenInfoWeekly {
  door_open_list: Array<FridgeDetailsDoorOpenInfoWeeklyItem>;
  average_open_count: number;
}
export class FridgeDetailsDoorOpenInfo {
  daily: FridgeDetailsDoorOpenInfoDaily;
  weekly: FridgeDetailsDoorOpenInfoWeekly;
  constructor() {
    this.daily = { door_open_list: [] };
    this.weekly = { door_open_list: [], average_open_count: 0 }
  }
}

// Push通知設定状態取得
export interface FridgeDetailsPushSettingsItem {
  param_name: string;       //設定名
                            // waterShortage : 給水不足
                            // coolOven : COOLING ASSIST通知
                            // iceCompleted : 製氷完了
                            // doorOpenInfo：ドア開閉無し
                            // errorOccured : エラー発生
  param_value: boolean;     // 設定値 true  : 設定オン、false : 設定オフ"		
  param_time: number | undefined;       // 設定期間(1～72時間)		
}
export class FridgeDetailsPushSettings {
  term_id: string;                                  // 端末ID(ACPFが発行)	
  param_list: Array<FridgeDetailsPushSettingsItem>;   // 設定状態の配列
  constructor() {
    this.term_id = "";
    this.param_list = [];
  }
}

// 月別削減金額取得
export interface FridgeDetailsReductionAmountListItem {
  date: string;		            // 年月（形式: YYYY-MM）
  reduction_amount: number;   // 削減金額
}
export class FridgeDetailsReductionAmountList {
  current_reduction_amount: number;		        // 今月の削減金額
  lastmonth_reduction_amount: number;         // 先月の削減金額 データが無い場合はnull
  lastyear_reduction_amount: number;          // 前年同月の削減金額 データが無い場合はnull
  reduction_amounts_list: Array<FridgeDetailsReductionAmountListItem>;  // 月ごとの削減金額リスト (MAX : 当月を含めた12か月)
  constructor() {
    this.current_reduction_amount = 0;
    this.lastmonth_reduction_amount = 0;
    this.lastyear_reduction_amount = 0;
    this.reduction_amounts_list = [];
  }
}

// 運転状態取得
export interface FridgeDetailsSettingListCoolingAssistItem {
  mode: string;                 // COOLING ASSISTモード  quench : 冷ます  cold : 急冷  frozen : 急凍
  default_time: number;         // 設定時間のデフォルト値 (1分単位)		
  upper_limit: number;          // 設定時間の上限値 (1分単位)		
  upper_limit_second: number;   // 設定時間の上限値 (10秒単位)		
  lower_limit: number;          // 設定時間の下限値 (1分単位)		
  lower_limit_second: number;   // 設定時間の下限値 (10秒単位)		
}
export interface FridgeDetailsSettingListQuickOperationButtonItem {
  mode: string;                         // COOLING ASSISTモード  quench : 冷ます   cold : 急冷  frozen : 急凍
  name: string;                         // 設定名		
  time: number;                         // 設定時間 (1分単位)		
  time_second: number | null;  	              // 設定時間(10秒単位)		
  upper_limit: number;                  // 設定時間の上限値 (1分単位)		
  upper_limit_second: number | null;           // 設定時間の上限値 (10秒単位)		
  lower_limit: number;                  // 設定時間の下限値 (1分単位)		
  lower_limit_second: number | null;           // 設定時間の下限値 (10秒単位)		
}
export interface FridgeDetailsSettingsList {
  appliance_id: string;                 // 通信用機器ID		
  operation_mode: string;               // 運転モード normal : 通常 coolOven : COOLING ASSIST運転 highLoading : 高負荷運転（がんばって運転中） econavi : エコナビ運転
  device_err_status: boolean;           // UHエラー発生状態  false : 異常なし  true  : 異常あり"	
  partial_mode: string;                 // パーシャルモード、chilled : チルド、weak : 弱、medium : 中、strong : 強
  partial_freezing_room_mode: string;   // パーシャル・冷凍切替室モード 
                                        // freezingWeak : 冷凍弱  freezingMedium : 冷凍中  freezingStrong : 冷凍強  partialWeak : パーシャル弱
                                        // partialMedium : パーシャル中  partialStrong : パーシャル強
  cold_room_mode: string;               // 冷蔵室モード weak : 弱  medium : 中  strong : 強
  freezing_room_mode: string;           // 冷凍室モード  weak : 弱  medium : 中  strong : 強
  fast_ice_status: boolean;             // 速氷状態 true  : ON false : OFF
  stop_ice_status: boolean;             // 製氷停止状態 true : ON false : OFF
  econavi_lamp_status: boolean;         // エコナビランプ表示状態 true  : ON  false : OFF
  cooloven_lamp_mode: string;           // COOLING ASSISTランプ表示モード off : 切  dark : 暗  bright : 明
  door_alarms_mode: string;             // ドアアラーム音量モード  medium : 中  big : 大
  coldroom_light_mode: string;          // 冷蔵室庫内照明モード  off : 切  dark : 暗  bright : 明
  pcroom_light_mode: string;            // バーシャル・チルド切り替え室照明モード off : 切  dark : 暗  bright : 明
  cooloven_mode: string;                // COOLING ASSISTモード  off : OFF  quench : 冷ます  cold : 急冷  frozen : 急凍
  cooloven_time: number;                // COOLING ASSIST設定時間 (1分単位)		
  cooloven_second: number;              // COOLING ASSIST設定時間 (10秒単位)		
  cooloven_remaining_time: number;      // COOLING ASSIST残り時間 (1分単位)
  cooloven_remaining_second: number;    // COOLING ASSIST残り時間 (1秒単位)
  cooloven_setting_list: Array<FridgeDetailsSettingListCoolingAssistItem>   // 各COOLING ASSISTモードのデフォルト値・設定可能範囲リスト (モード数の３つ分)		
  cooloven_in_seconds: boolean;         // COOLING ASSIST秒単位設定 true  : 機能有り  false : 機能無し
  house_sitting_status: boolean;        // お留守番モード状態 true  : ON  false : OFF
  pre_cooling_status: boolean;          // お買い物準備モード状態  true  : ON  false : OFF
  winter_setting_status: boolean;       // 冬季省エネ運転状態  true  : ON  false : OFF
  quick_button_setting_list: Array<FridgeDetailsSettingListQuickOperationButtonItem>;   // クイック操作ボタンの設定 (モード数の３つ分)		
  firmware_update_status: string;       // 本体ファームウェア更新状態 noUpdate : 更新なし  needToUpdate : 更新あり  inprogress : 更新処理中
  firmware_current_version: string;     // 現行ファームウェアバージョン (半角英数記号型)		
  firmware_latest_version: string;      // 最新ファームウェアバージョン (半角英数記号型)		
  fresh_frozen_status: boolean;         // 新鮮凍結状態  true  : ON  false : OFF
  outage_prepare_status: boolean;       // 停電そなえモード運転状態   true  : ON  false : OFF
  partial_half_defrost_mode: string;    // パーシャル半解凍モード off: OFF, 7h: 7H, 5h: 5H
  sc_room_temperature: string;          // SC室温度レベル設定 weak : 弱、medium : 中、strong : 強
}

// 冷蔵庫機能一覧
export interface FridgeDetailsFunctionListItem {
  function_id: string;        // 機能ID (半角英数型)
                              //    coolOven : COOLING ASSIST
                              //    recipe: レシピ
                              //    doorOpenInfo : ドア開閉ログ
                              //    houseSitting : お留守番モード
                              //    initRequired：初期化要否
                              //    quickButton : クイック操作ボタン
                              //    firmwareUpdate : 本体ファームウェア更新
                              //    partialFreezingRoom : パーシャル・冷凍切替室
                              //    econaviLedOnOff: エコナビランプ表示入切
                              //    pcroomLightMode: パーシャル・チルド切替室照明
                              //    freshFrozen: 新鮮凍結
                              //    fastGood: はやうま
                              //    outagePrepare: 停電そなえモード
                              //    aiCooling: AIクーリング
                              //    partialHalfDefrost: パーシャル半解凍
                              //    scRoomTemperature:SC室温度レベル設定
  function_value: boolean;    // 機能値
                              //    true  : 機能有り
                              //    false : 機能無し
}
export interface FridgeDetailsFunctionListSpecItem {
  spec_id: string;            // SPEC ID (半角英数型)
                              //   roomType : 冷蔵庫室内構造タイプ
  spec_value: number;         // SPEC値
                              //   spec_idが""roomType""の場合
                              //     1: 冷凍室真ん中タイプ
                              //     2: 野菜室真ん中タイプ
}
export class FridgeDetailsFunctionList {
  reizo_function_list: Array<FridgeDetailsFunctionListItem>;    // 冷蔵庫機能の配列
  reizo_spec_list:Array<FridgeDetailsFunctionListSpecItem>;     // 冷蔵庫SPECの配列
  product_code: string;                                         // 品番

  constructor() {
    this.reizo_function_list = [];
    this.reizo_spec_list = [];
    this.product_code = "";
  }
}

// 機器制御実行
export interface FridgeDetailsSetSettingsListQuickOperationButtonItem {
  mode: string;                 // COOLING ASSISTモード quench : 冷ます cold : 急冷 frozen : 急凍
  name: string;                 // 設定名		
  time: number;                 // 設定時間 (1分単位)		
  time_second: number | null;   // 設定時間(10秒単位)		
}
export class FridgeDetailsSetSettingsList {
  partial_mode: string | undefined;                 // パーシャルモード chilled : チルド weak : 弱 medium : 中 strong : 強
  partial_freezing_room_mode: string | undefined;   // パーシャル・冷凍切替室モード
                                                    // freezingWeak : 冷凍弱 freezingMedium : 冷凍中 freezingStrong : 冷凍強
                                                    // partialWeak : パーシャル弱 partialMedium : パーシャル中 partialStrong : パーシャル強
  cold_room_mode: string | undefined;               // 冷蔵室モード weak : 弱 medium : 中 strong : 強
  freezing_room_mode: string | undefined;           // 冷凍室モード weak : 弱 medium : 中 strong : 強
  fast_ice_status: boolean | undefined;             // 速氷状態 true  : ON false : OFF ※新鮮凍結状態と同時にONが設定された場合はパラメータエラーとなる。
  stop_ice_status: boolean | undefined;             // 製氷停止状態  true  : ON false : OFF
  econavi_lamp_status: boolean | undefined;         // エコナビランプ表示状態 true  : ON false : OFF
  cooloven_lamp_mode: string | undefined;           // COOLING ASSISTランプ表示モード off : 切 dark : 暗 bright : 明
  door_alarms_mode: string | undefined;             // ドアアラーム音量モード medium : 中 big : 大
  coldroom_light_mode: string | undefined;          // 冷蔵室庫内照明モード off : 切 dark : 暗 bright : 明
  pcroom_light_mode: string | undefined;            // バーシャル・チルド切り替え室照明モード off : 切 dark : 暗 bright : 明
  cooloven_mode: string | undefined;                // COOLING ASSISTモード off : OFF quench : 冷ます cold : 急冷 frozen : 急凍
  cooloven_time: number | undefined;                // COOLING ASSIST設定時間 (1分単位)
  cooloven_second: number | undefined;              // COOLING ASSIST設定時間 (10秒単位)
  quick_button_setting_list: Array<FridgeDetailsSetSettingsListQuickOperationButtonItem> | undefined;   // クイック操作ボタンの設定 (モード数の３つ分)
                                                                                                        // ・変更する設定名、設定時間のみモードと共に設定する。
                                                                                                        // ・いずれかのモードの設定時間を変更する場合、全てのモードの設定時間を設定する。
  fresh_frozen_status: boolean | undefined;         // 新鮮凍結状態 true  : ON false : OFF ※速氷状態と同時にONが設定された場合はパラメータエラーとなる。
  partial_half_defrost_mode: string | undefined;    // パーシャル半解凍モード  off  : OFF 7h : 7H  5h : 5H
  sc_room_temperature: string | undefined;          // SC室温度レベル設定 weak : 弱、medium : 中、strong : 強

  constructor() {
    this.partial_mode = "chilled";
    this.partial_freezing_room_mode = "freezingWeak";
    this.cold_room_mode = "weak";
    this.freezing_room_mode = "weak"; 
    this.fast_ice_status = false;
    this.stop_ice_status = false;
    this.econavi_lamp_status = false;
    this.cooloven_lamp_mode = "off";
    this.door_alarms_mode = "medium";
    this.coldroom_light_mode = "off";
    this.pcroom_light_mode = "off";
    this.cooloven_mode = "off";
    this.cooloven_time = 0;
    this.cooloven_second = 0;
    this.quick_button_setting_list = [];
    this.fresh_frozen_status = false;
    this.partial_half_defrost_mode = "off";
    this.sc_room_temperature = "weak"
  }
}
export class FridgeDetailsSettingsInitialList {
  partial_mode: string | undefined;                 // パーシャルモード chilled : チルド weak : 弱 medium : 中 strong : 強
  partial_freezing_room_mode: string | undefined;   // パーシャル・冷凍切替室モード
                                                    // freezingWeak : 冷凍弱 freezingMedium : 冷凍中 freezingStrong : 冷凍強
                                                    // partialWeak : パーシャル弱 partialMedium : パーシャル中 partialStrong : パーシャル強
  cold_room_mode: string;                           // 冷蔵室モード weak : 弱 medium : 中 strong : 強
  freezing_room_mode: string;                       // 冷凍室モード weak : 弱 medium : 中 strong : 強
  fast_ice_status: string;                         // 速氷状態 true  : ON false : OFF ※新鮮凍結状態と同時にONが設定された場合はパラメータエラーとなる。
  stop_ice_status: string;                         // 製氷停止状態  true  : ON false : OFF
  econavi_lamp_status: string | undefined;         // エコナビランプ表示状態 true  : ON false : OFF
  cooloven_lamp_mode: string | undefined;           // COOLING ASSISTランプ表示モード off : 切 dark : 暗 bright : 明
  door_alarms_mode: string;                         // ドアアラーム音量モード medium : 中 big : 大
  coldroom_light_mode: string;                      // 冷蔵室庫内照明モード off : 切 dark : 暗 bright : 明
  pcroom_light_mode: string | undefined;            // バーシャル・チルド切り替え室照明モード off : 切 dark : 暗 bright : 明
  cooloven_mode: string | undefined;                // COOLING ASSISTモード off : OFF quench : 冷ます cold : 急冷 frozen : 急凍
  cooloven_time: number | undefined;                // COOLING ASSIST設定時間 (1分単位)
  cooloven_second: number | undefined;              // COOLING ASSIST設定時間 (10秒単位)
  quick_button_setting_list: Array<FridgeDetailsSetSettingsListQuickOperationButtonItem> | undefined;   // クイック操作ボタンの設定 (モード数の３つ分)
                                                                                                        // ・変更する設定名、設定時間のみモードと共に設定する。
                                                                                                        // ・いずれかのモードの設定時間を変更する場合、全てのモードの設定時間を設定する。
  fresh_frozen_status: string | undefined;         // 新鮮凍結状態 true  : ON false : OFF ※速氷状態と同時にONが設定された場合はパラメータエラーとなる。
  partial_half_defrost_mode: string | undefined;    // パーシャル半解凍モード  off  : OFF 7h : 7H  5h : 5H
  sc_room_temperature: string | undefined;          // SC室温度レベル設定 weak : 弱、medium : 中、strong : 強

  constructor() {
    this.partial_mode = "chilled";
    this.partial_freezing_room_mode = "freezingWeak";
    this.cold_room_mode = "weak";
    this.freezing_room_mode = "weak"; 
    this.fast_ice_status = "false"
    this.stop_ice_status = "false";
    this.econavi_lamp_status = "false";
    this.cooloven_lamp_mode = "off";
    this.door_alarms_mode = "medium";
    this.coldroom_light_mode = "off";
    this.pcroom_light_mode = "off";
    this.cooloven_mode = "off";
    this.cooloven_time = 0;
    this.cooloven_second = 0;
    this.quick_button_setting_list = [];
    this.fresh_frozen_status = "false";
    this.partial_half_defrost_mode = "off";
    this.sc_room_temperature = "weak"
  }
}

// クーリングアシストのマイリスト
export interface FridgeDetailsMylistItem {
  mylist_id: number;        // マイリストID		
  nickname: string;         // 名前		
  cooloven_mode: string;    // COOLING ASSISTモード
                            //   quench : 冷ます
                            //   cold : 急冷
                            //   frozen : 急凍
  cooloven_time: number;    // COOLING ASSIST設定時間 (1分単位)		
  cooloven_second: number;  // COOLING ASSIST設定時間 (10秒単位)		
}

export class FridgeDetailsMylist {
  mylist_list: Array<FridgeDetailsMylistItem>;    // マイリストの配列
  mylist_max_num: number;                         // マイリスト登録上限数

  constructor() {
    this.mylist_list = [];
    this.mylist_max_num = 0;
  }
}

export class FridgeDetailsCoolingAssistSettingList {
  appliance_id: string;             // 通信ID
  device_err_status: boolean;           // UHエラー発生状態  false : 異常なし  true  : 異常あり"	
  cooloven_setting_list: Array<FridgeDetailsSettingListCoolingAssistItem>;    // クーリングアシスト設定リスト
  cooloven_in_seconds: boolean;         // COOLING ASSIST秒単位設定 true  : 機能有り  false : 機能無し

  constructor() {
    this.appliance_id = "";
    this.cooloven_setting_list = [];
    this.device_err_status = false;
    this.cooloven_in_seconds = false;
  }
}

//
// 内部で使用
//

// 週毎のドア開閉情報
export class FridgeDetailsDoorMonitorWeeklyArrayData {
  list: Array<FridgeDetailsDoorOpenInfoWeeklyItem>;
  constructor() {
    this.list = [];
  }
}

// ドアアラーム表示
export class FridgeDetailsDoorMonitorWeeklyItemCautionStyle {
  visible: boolean;
  marginTop: string;
  constructor(maxValue: number, count: number, isAlart: boolean, maxSize: number, yShiftSize: number, topAdjust: number) {
    if (isAlart) {
      this.visible = true;
      let ratio = count / maxValue;
      if (ratio > 1) {
        ratio = 1;
      }
      const positionFromBottom = maxSize * ratio + yShiftSize;
      const marginTop = topAdjust - positionFromBottom;
      this.marginTop = `${marginTop}rem`
    } else {
      this.visible = false;
      this.marginTop = "0";
    }
  }
}

// 設定ダイアログのインターフェース
export interface FridgeDetailsDisplaySettingsListItem {
  index: number;          // インデックス
  itemName: string;       // 名称
  value: string;          // 値
}

// 冷蔵庫のクーリング・アシスト等のモード
export const FRIDGE_DETAILS_COOLING_MODE = {
  QUENCH: "quench",
  COLD: "cold",
  FROZEN: "frozen"
}

// 冷蔵庫のクーリング・アシスト等のモードの文字列
export const FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING = {
  QUENCH: "冷ます",
  COLD: "急冷",
  FROZEN: "急凍"
}

// クーリングアシスト設定
export class FridgeCoolingAssistSettingItem {
  cooloven_mode: string;
  cooloven_time: number;
  cooloven_second: number | undefined;
  constructor() {
    this.cooloven_mode = FRIDGE_DETAILS_COOLING_MODE.QUENCH;
    this.cooloven_time = 0;
    this.cooloven_second = undefined;
  }
}

// マイリスト設定用
export class FridgeDetailsMyAssistSettingItem {
  mylist_id: number;                // マイリストID
  nickname: string;                 // 名前
  cooloven_mode: string;            // COOLING ASSISTモード
                                    //   quench : 冷ます
                                    //   cold : 急冷
                                    //   frozen : 急凍
  cooloven_time: number;            // COOLING ASSIST設定時間 (1分単位)
  cooloven_second: number;          // COOLING ASSIST設定時間 (10秒単位)
  valid_second: boolean;           // 秒有効

  constructor() {
    this.mylist_id = 0;
    this.nickname = "";
    this.cooloven_mode = FRIDGE_DETAILS_COOLING_MODE.QUENCH;
    this.cooloven_time = 0;
    this.cooloven_second = 0;
    this.valid_second = false;
  }
}

// 冷蔵庫機能ID
export const FRIDGE_DETAILS_FUNCTION_ID = {
  COOLOVEN: "coolOven",                         // クーリング・アシスト
  RECIPE: "recipe",                             // レシピ
  DOOROPENINFO: "doorOpenInfo",                 // ドア開閉ログ
  HOUSESITTING: "houseSitting",                 // お留守番モード
  INITREQUIRED: "initRequired",                 // 初期化要否
  QUICKBUTTON: "quickButton",                   // クイック操作ボタン
  FIRMWAREUPDATE: "firmwareUpdate",             // 本体ファームウェア更新
  PARTIALFREEZINGROOM: "partialFreezingRoom",   // パーシャル・冷凍切替室
  ECONAVILEDONOFF: "econaviLedOnOff",           // エコナビランプ表示入切
  PCROOMLIGHTMODE: "pcroomLightMode",           // パーシャル・チルド切替室照明
  FRESHFROZEN: "freshFrozen",                   // 新鮮凍結
  FASTGOOD: "fastGood",                         // はやうま
  OUTAGEPREPARE: "outagePrepare",               // 停電そなえモード
  AICOOLING: "aiCooling",                       // AIクーリング
  PARTIALHALFDEFROST: "partialHalfDefrost",     //  パーシャル半解凍
  SCROOMTEMPARATURE: "scRoomTemperature"        // SC（クーリングアシスト）室温度レベル設定
}

// 強、中、弱
export const FRIDGE_DETAILS_STRENGTH = {
  WEAK: "weak",       // 弱
  MEDIUM: "medium",   // 中
  STRONG: "strong"    // 強
}

// 照明
export const FRIDGE_DETAILS_LIGHT_MODE = {
  OFF: "off",         // オフ
  DARK: "dark",       // 暗
  BRIGHT: "bright"    // 明
}

// パーシャル冷凍モード
export const FRIDGE_DETAILS_PARTIAL_FROZEN_MODE = {
  FREEZING_WEAK: "freezingWeak",
  FREEZING_MEDIUM: "freezingMedium",
  FREEZING_STRONG: "freezingStrong",
  PARTIAL_WEAK: "partialWeak",
  PARTIAL_MEDIUM: "partialMedium",
  PARTIAL_STRONG: "partialStrong"
}

// パーシャル/チルド・モード
export const FRIDGE_DETAILS_PARTIAL_CHILLED_MODE = {
  CHILLED: "chilled",
  PARTIAL_WEAK: "weak",
  PARTIAL_MEDIUM: "medium",
  PARTIAL_STRONG: "strong"
}

// 音量
export const FRIDGE_DETAILS_VOLUME_MODE = {
  MEDIUM: "medium",
  BIG: "big",
}

// パーシャル半解凍
export const FRIDGE_DETAILS_PARTIAL_HALF_DEFROST = {
  OFF: "off",
  SEVENHOUR: "7h",
  FIVEHOUR: "5h"
}

// 文言リスト
export interface FridgeDetailsDisplayDescriptionListValueDisplayValue {
  section_id: string;
  contents: string;
}
export interface FridgeDetailsDisplayDescriptionListValue {
  screen_id: string;
  display_value_list: Array<FridgeDetailsDisplayDescriptionListValueDisplayValue>;
}
export class FridgeDetailsDisplayDescriptionList {
  screen_list: Array<FridgeDetailsDisplayDescriptionListValue>;
  constructor() {
    this.screen_list = [];
  }
}

// 通知設定
export const FRIDGE_DETAILS_PUSH_SETTINGS = {
  ERROROCCURED: "errorOccured",
  COOLOVEN: "coolOven",
  WATERSHORTAGE: "waterShortage",
  ICECOMPLETED: "iceCompleted",
  DOOROPENINFO: "doorOpenInfo",
  PARTIALHALFDEFROST: "partialHalfDefrost"
}

export interface FridgeDetailsState {
  econaviInfo: FridgeDetailsEconaviInfo | null;
  doorOpenInfo: FridgeDetailsDoorOpenInfo | null;
  pushSettings: FridgeDetailsPushSettings | null;
  reductoinInfo: FridgeDetailsReductionAmountList | null;
  settings: FridgeDetailsSettingsList | null;
  operationSettings: FridgeDetailsSettingsList | null;
  functionList: FridgeDetailsFunctionList | null;
  settingsBuffer: FridgeDetailsSetSettingsList | null;
  pushSettingsBuffer: FridgeDetailsPushSettings | null;
  myAssist: FridgeDetailsMylist | null;
  coolingAssisySettings: FridgeDetailsCoolingAssistSettingList | null;
  coolingAssisttopTabIdex: number | null;
  doorMonitorTabIndex: number | null;
  doorMonitorDailyTabIndex: number | null;
  descriptionList: FridgeDetailsDisplayDescriptionList | null;
  settingsInitialValue: FridgeDetailsSetSettingsList | null;
}

